import React, { useState } from 'react';
import { Radio, Zap, Signal, Wifi, ArrowRight, Check } from 'lucide-react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Imgbanner from '../Components/Images/eas/eas_banner.png'
import img1 from '../Components/Images/eas/1.png';
import img2 from '../Components/Images/eas/2.png';
import img3 from '../Components/Images/eas/3.png';
import img4 from '../Components/Images/eas/4.png';
import img5 from '../Components/Images/eas/5.png';
import img6 from '../Components/Images/eas/6.png';
import img7 from '../Components/Images/eas/rf/14.png';
import img8 from '../Components/Images/eas/rf/15.png';
import img9 from '../Components/Images/eas/rf/16.png';
import img10 from '../Components/Images/eas/rf/17.png';
import '../Pages/EAS.css'

const EASAntennaSection = () => {
  const [activeTab, setActiveTab] = useState('AM');

  const amAntennas = [
    {
      id: 1,
      name: 'IVORY AM 9023',
      description: 'High quality ABS antenna with curved design and extremely low false alarms',
      frequency: '58 kHz',
      material: 'ABS',
      features: ['High detection rate', 'Low false alarm', 'Curved design', 'Compatible with AM tags/labels'],
      image: img1
    },
    {
      id: 2,
      name: 'Carbon AM 8120',
      description: 'Next-generation AM detection technology with sleek modern styling',
      frequency: '58 kHz',
      material: 'ABS ',
      features: ['Next-gen detection', 'Sleek design', 'Jam/anti-interference protection (model-dependent)'],
      image: img2
    },
    {
      id: 3,
      name: 'EDGE AM 9019',
      description: 'Its a sleek security solution that prevents theft while doubling as a powerful advertising medium.',
      frequency: '58 kHz',
      material: 'acrylic',
      features: ['Security & Advertising Solution', 'Superior Detection', 'Smart Sensitivity'],
      image: img4
    },
    {
      id: 4,
      name: 'FROST AM 8120',
      description: 'Crafted with durable ABS material, this antenna combines strength and elegance, making it ideal for modern retail environments.',
      frequency: '58 kHz',
      material: 'ABS antenna',
      features: ['Durable Acrylic Design', 'Low Power Consumption ', 'Exceptional Detection'],
      image: img3
    },
    {
      id: 5,
      name: 'PLEXI AM 350',
      description: 'Engineered with premium acrylic material, delivers both durability and a modern, transparent design that blends into retail environment.',
      frequency: '58 kHz',
      material: 'Acrylic antenna',
      features: ['Smart Sensitivity Control', 'No External Controller', 'Flexible Installation Options'],
      image: img5
    },
    {
      id: 6,
      name: 'PLEXI AM 450',
      description: 'Built with premium-grade acrylic, this antenna offers a crystal-clear, modern design that perfectly complements any retail space',
      frequency: '58 kHz',
      material: 'Acrylic antenna',
      features: ['Flexible Installation Options', 'Smart Sensitivity Control', 'Premium Acrylic Design'],
      image: img6
    }
  ];

  const rfAntennas = [
    {
      id: 1,
      name: 'M609 DT-PLEXI',
      description: 'Crafted from high-quality acrylic, this RF EAS antenna ensures high detection with minimal false alarms.',
      frequency: '8.2MHz',
      material: 'Acrylic antenna',
      features: ['Superior detection', 'Premium acrylic construction', 'Excellent noise reduction'],
      image: img7
    },
    {
      id: 2,
      name: '6116 DT-SLIM',
      description: 'With dual-color LED lights and noise reduction technology, it delivers reliable performance and a sleek modern look',
      frequency: '8.2MHz',
      material: 'Aluminium and acrylic',
      features: ['Flexible installation configuration', 'Minimal false alarm', 'Customizable PCB board option'],
      image: img8
    },
    {
      id: 3,
      name: '6811 DT-SLEEK',
      description: 'Engineered for high detection accuracy and ultra-low false alarms, it keeps your products safe.',
      frequency: '8.2MHz',
      material: 'Aluminium and acrylic',
      features: ['Remote service', 'Super detection', 'Minimal false alarm'],
      image: img9
    },
    {
      id: 4,
      name: '6881 DT',
      description: 'With dual-color LED lights and advanced noise reduction, its not just protection – its innovation at its finest.',
      frequency: '8.2MHz',
      material: 'Acrylic system',
      features: ['Super detection', 'Build from sustainable materials', 'Customizable dual color LED'],
      image: img10
    }
  ];

  const currentAntennas = activeTab === 'AM' ? amAntennas : rfAntennas;

  return (
    <div className="eas-antenna-section position-relative overflow-hidden ">
      {/* Banner Image */}
      <div className="banner-container position-relative mt-3">
        <img
          src={Imgbanner}
          alt="Banner"
          className="w-100 h-120 object-fit-cover"
        />
      </div>

      {/* Animated background elements */}
      <div className="position-absolute top-0 start-0 w-100 h-100 opacity-40">
        <div className="bg-bubble bg-bubble-1"></div>
        <div className="bg-bubble bg-bubble-2"></div>
        <div className="bg-bubble bg-bubble-3"></div>
      </div>

      <div className="position-relative mt-5 pt-5" style={{ zIndex: 10 }}>
        <div className="container py-5">
          {/* Technology Toggle */}
          <div className="d-flex justify-content-center mb-5">
            <div className="tech-toggle-wrapper p-2">
              <div className="d-flex gap-2">
                {['AM', 'RF'].map((tech) => (
                  <button
                    key={tech}
                    onClick={() => setActiveTab(tech)}
                    className={`btn tech-toggle-btn d-flex align-items-center gap-3 px-4 py-3 ${
                      activeTab === tech ? 'active' : ''
                    }`}
                  >
                    {tech === 'AM' ? <Radio size={20} /> : <Wifi size={20} />}
                    <span className="fw-semibold">
                      {tech === 'AM' ? 'AM Technology' : 'RF Technology'}
                    </span>
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Antenna Grid */}
          <div className="row g-4 mb-5">
            {currentAntennas.map((antenna, index) => (
              <div
                key={antenna.id}
                className="col-12 col-lg-6 col-xl-4"
                style={{
                  animationDelay: `${index * 150}ms`
                }}
              >
                <div className="antenna-card h-100 p-4">
                  <div className="d-flex justify-content-between align-items-start mb-4">
                    <div className="icon-wrapper">
                      {activeTab === 'AM' ? 
                        <Radio size={32} className="text-white" /> : 
                        <Zap size={32} className="text-white" />
                      }
                    </div>
                    <div className="text-end">
                      <div className="small text-secondary">Professional Grade</div>
                    </div>
                  </div>

                  <h3 className="antenna-title fs-4 fw-bold mb-3">
                    {antenna.name}
                  </h3>
                  
                  <p className="text-secondary mb-4">
                    {antenna.description}
                  </p>

                  <div className="antenna-image mb-4">
                    <img src={antenna.image} alt={antenna.name} className="img-fluid" />
                  </div>

                  <div className="specs-list mb-4">
                    <div className="d-flex justify-content-between py-2 border-bottom spec-item">
                      <span className="text-secondary">Frequency Range</span>
                      <span className="fw-medium">{antenna.frequency}</span>
                    </div>
                    <div className="d-flex justify-content-between py-2 border-bottom spec-item">
                      <span className="text-secondary">Material</span>
                      <span className="fw-medium">{antenna.material}</span>
                    </div>
                  </div>

                  <div className="features-list mb-4">
                    {antenna.features.map((feature, idx) => (
                      <div key={idx} className="d-flex align-items-center gap-3 mb-2">
                        <Check size={20} className="text-success flex-shrink-0" />
                        <span className="text-secondary">{feature}</span>
                      </div>
                    ))}
                  </div>

                  <button className="btn gradient-bg text-teal w-100 d-flex align-items-center justify-content-center gap-3 py-3 view-specs-btn">
                    <span>View Specifications</span>
                    <ArrowRight size={20} className="arrow-icon" />
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Bottom CTA */}
          <div className="cta-section text-center p-5">
            <h2 className="display-5 fw-bold mb-4">
              Need Custom Solutions?
            </h2>
            <p className="lead text-secondary mb-4 mx-auto" style={{ maxWidth: '800px' }}>
              Our engineering team can design custom antenna systems tailored to your specific emergency alert requirements and coverage needs.
            </p>
            <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center">
              <button className="btn d-flex gradient-bg text-teal align-items-center justify-content-center gap-3 px-4 py-3">
                <Signal size={20} />
                <span>Contact Engineering</span>
              </button>
              <button className="btn gradient-bg text-teal d-flex align-items-center justify-content-center gap-3 px-4 py-3 btn-download">
                <span>Download Catalog</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EASAntennaSection;